import { render, staticRenderFns } from "./introDialog.vue?vue&type=template&id=0098c381&scoped=true&"
import script from "./introDialog.vue?vue&type=script&lang=js&"
export * from "./introDialog.vue?vue&type=script&lang=js&"
import style0 from "./introDialog.vue?vue&type=style&index=0&id=0098c381&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098c381",
  null
  
)

export default component.exports